import { Translation } from './translation';

export const en_de: Translation = {
  common: {
    apply: 'Apply',
    type: 'Type',
    showLess: 'Show less',
    showMore: 'Show more',
    map: 'Map',
    list: 'List',
    results: '{count} results',
    continue: 'Continue',
    back: 'Back',
    currency: {
      short: 'EUR',
      price: `{price} €`,
      pricePerMonth: `{price} € / month`,
      pricePerSquareMeter: `{price} €/m<sup>2</sup>`,
    },
  },
  mapPrivacy: {
    text: `
      In order to display the map of the third-party provider Google Maps,
      we need your consent to the use of cookies.
    `,
    button: `Manage cookies`,
  },
  filters: {
    common: {
      reset: 'Reset',
      resetAll: 'Reset all',
      deleteAll: 'Delete all',
      filter: 'Filter',
      additionalFilters: 'Additional filters',
      showResults: 'Show results',
      showXResults: 'Show {count} results',
      modifySearch: 'Modify search',
      in: 'in',
      title_rent: {
        none: 'Rent property',
        house: 'Houses for rent',
        flat: 'Flats for rent',
        commercial: 'Commercial properties for rent',
      },
      title_buy: {
        none: 'Buy property',
        house: 'Houses for sale',
        flat: 'Flats for sale',
        land: 'Estates for sale',
        income: 'Income properties for sale',
        commercial: 'Commercial properties for sale',
      },
    },
    search: {
      label: 'State, city, postcode, object ID, ...',
      noResults: 'No results. Please check your spelling.',
    },
    contractType: {
      buy: 'Buy',
      rent: 'Rent',
    },
    category: {
      main: {
        label: 'Category',
        all: 'All',
        house: 'House',
        apartment: 'Flat',
        estate: 'Estate',
        incomeProperty: 'Income property',
        commercial: 'Commercial',
      },
      sub: {
        businessHouse: 'Commercial building',
        garageParking: 'Parking space / garage',
        commercialResidentialBuilding: 'Residential and commercial building',
        office: 'Office',
        shop: 'Shop',
        warehouse: 'Warehouse',
        factory: 'Factory',
        hotel: 'Hotel',
        restaurant: 'Restaurant',
        practice: 'Practice',
        multiFamilyHouse: 'Multi-family house',
        buildingLand: 'Building land',
        agriculturalLand: 'Agricultural land',
        industrialLand: 'Industrial land',
        atticFlat: 'Attic flat',
        roofFlat: 'Penthouse',
        maisonette: 'Duplex',
        studio: 'Studio apartment',
        terraceFlat: 'Flat with terrace',
        loft: 'Loft',
        gardenFlat: 'Flat with a garden',
        floorFlat: 'Flat',
        holidayFlat: 'Holiday flat',
        furnishedFlat: 'Furnished flat',
        oneFamilyHouse: 'One-family house',
        midTerraceHouse: 'Mid-terrace house',
        endTerraceHouse: 'End-terrace house',
        rustico: 'Rustico',
        semidetachedHouse: 'Semi-detached house',
        terraceHouse: 'Terrace house',
        farmhouse: 'Farmhouse',
        mansion: 'Mansion',
        holidayHouse: 'Holiday house',
        countryHouse: 'Country house',
        twoFamilyHouse: 'Two-family house',
        chalet: 'Chalet',
      },
    },
    price: {
      label: 'Price',
    },
    roomCount: {
      label: 'Rooms',
      to: 'to',
    },
    livingSpace: {
      label: 'Living space',
    },
    propertySpace: {
      label: 'Land size',
    },
    usageSpace: {
      label: 'Usable area',
    },
    sort: {
      label: 'Sort',
      newest: 'Newest properties',
      lowestPrice: 'Price (ascending)',
      highestPrice: 'Price (descending)',
    },
    rateOfReturn: {
      label: 'gross yield',
    },
    units: {
      label: 'units',
    },
  },
  regionSearch: {
    city: 'City',
    village: 'Town',
    county: 'County',
    suburb: 'Suburb',
    state: 'State',
  },
  noResults: {
    title: 'No results',
    text: `
      Save your search and be notified about
      the latest properties that match your criteria.
    `,
  },
  searchSubscription: {
    setup: 'Setup search subscription',
    save: 'Save search subscription',
    overlay: {
      title: 'Search subscription',
      text: `
        We would be happy to let you know by
        email as soon as a property is available that meets your requirements.
      `,
      showResults: 'Show search results',
      changeFilter: {
        desktop: {
          part1: 'You can edit your criteria in the',
          button: 'filters',
          part2: ' ',
        },
        mobile: {
          button: 'Edit search criteria',
        },
      },
    },
    stepper_title: {
      desktop: {
        step1: 'Set search criteria',
        step2: 'Set search criteria',
        step3: 'Finalise search subscription',
        step_final: 'Search subscription saved',
      },
      mobile: {
        step1: 'Set search criteria',
        step2: 'Finalise search subscription',
        step_final: 'Search subscription saved',
      },
    },
    search: {
      label: 'State, city, postcode, ...',
    },
    location: 'Location',
    andRadius: 'and radius',
    yourDetails: 'Your details',
    yourSearchCriteria: 'Your search criteria',
    toObjectSearch: 'To object search',
    cookieMessage: {
      description: `
        To display the contact form, please accept the targeting cookies.
      `,
      button: 'Manage cookies',
    },
    form: {
      firstName: 'First name',
      firstNameRequired: 'First name is required.',
      lastName: 'Last name',
      lastNameRequired: 'Last name is required.',
      email: 'E-mail',
      emailRequired: 'E-mail is require',
      receiveNewsletter: 'Subscribe to the ImmoSky newsletter',
      newsletterHint: 'You can unsubscribe at any time.',
      acceptPrivacyHint: `
      You hereby accept the <a target="_blank" href="/en/gtc/">terms & conditions</a> & <a target="_blank" href="/en/data-protection/">privacy policy</a> of ImmoSky.
      `,
      thirdPartyHint: `
        Your data will not be shared with third parties.
        You can find our <a target="_blank" href="/en/data-protection/">Privacy Policy here</a>.<br>
        This site is protected by
        <a target="_blank" href="https://www.google.com/recaptcha/about/">reCAPTCHA</a> and the
        <a target="_blank" href="https://policies.google.com/privacy">Google Privacy</a>
        Policy and Terms of Service apply.
      `,
    },
    successMessage: {
      title: 'Registered for notifications',
      paragraph1: `
        You will receive a confirmation link by email shortly.
      `,
      paragraph2: `
        As soon as you have opened the link and confirmed, you will regularly receive emails with properties that meet your requirements.
      `,
    },
  },
  similarObjects: {
    title: 'Similar properties nearby',
    xResults: '{count} results',
    modifySearch: {
      text: `
        Modify the search to see more results.
      `,
      button: 'Adjust search',
    },
  },
  realEstateObject: {
    sold: 'Sold',
    priceOnRequest: 'Price on request',
    reserved: 'Reserved',
    topOffer: 'Top offer',
    virtualTour: 'Virtual tour',
  },
};
